<template>
    <ion-page>
        <ion-header class="toolbar-shadow">
            <ion-toolbar color="custom-white">
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <mdicon class="text-primary" name="close"></mdicon>
                    </ion-button>
                </ion-buttons>
                <ion-title>Rapportage</ion-title>

                <ion-buttons slot="end">
                    <!-- needs work -->
                    <ion-button v-if="report_generation_status == 'report_ready'" @click="share()">
                        <mdicon class="text-primary" name="share"></mdicon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <vue-pdf-app v-if="report_generation_status == 'report_ready'" style="height: 100vh;" :pdf="config.url"
                :config="config">

            </vue-pdf-app>

            <no-data icon="file-document-alert-outline" v-else-if="report_generation_status == 'error'">
                <template #info>
                    <p class="no-data-subtitle mt-3">
                        {{ message }}
                    </p>
                </template>
            </no-data>


            <Loading v-else></Loading>
        </ion-content>

    </ion-page>
</template>

<script>

import VuePdfApp from "vue3-pdf-app";
// import this to use default icons for buttons
import "vue3-pdf-app/dist/icons/main.css";
import { modalController } from "@ionic/vue";
import { Share } from '@capacitor/share';
import Loading from "@/components/Loading.vue";
import { db } from "@/services/db";
// filesystem capacitor to store pdf in cache
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import NoData from "./NoData.vue";

export default {
    name: "PDFviewer",
    components: {
        VuePdfApp,
        Loading,
        NoData
    },
    props: {
        url: String
    },
    data() {
        return {
            config: {
                toolbar: true,
                sidebar: false,
                locale: "nl",
                url: this.url,
                theme: this.$store.getters.getDarkMode ? "dark" : "light", //does not work

            },
            report_generation_status: "generating",
            message: "Er is een fout opgetreden bij het genereren van het rapport",
            echo: null,
            notifications: [],
            pollingInterval: null
        };
    },
    created() {
        this.generatePdf();
    },
    beforeUnmount() {
        this.stopListening();
    },
    methods: {
        async startListening() {
            if (!this.$store.getters.isAuthenticated) {
                return;
            }

            const userId = this.$store.getters.getUser.id;
            const brokerClientCode = localStorage.getItem('client_code');

            this.echo.private('users.' + userId + '.client.' + brokerClientCode)
                .notification((notification) => {
                    this.$store.dispatch('setEventNotification', notification)
                });

            console.log('Subscribed to report generation channel')
        },
        async stopListening() {
            if (this.echo) {
                console.log('Disconnecting from echo')
                const userId = this.$store.getters.getUser.id;
                const brokerClientCode = localStorage.getItem('client_code');

                this.echo.leave('users.' + userId + '.client.' + brokerClientCode);
            }
        },
        async generatePdf() {
            if (this.url) {
                this.config.url = this.url;
                this.report_generation_status = 'report_ready';
                return;
            }

            // Haal alle notificaties op
            await this.$requests.get('notifications', '/notifications');
            this.notifications = await db.notifications.toArray();

            await this.$axios
                .get(localStorage.getItem("api_url") + "/pdf-report/" + this.$store.getters.getInspectionId, {
                    validateStatus: (status) => {
                        return status >= 200 && status < 300;
                    }
                })
                .then(() => {
                    this.report_generation_status = "generating";
                    this.startPolling();
                })
                .catch((error) => {
                    console.log(error);
                    this.report_generation_status = "error";
                    if (error.response.data.error && error.response.data.error[0].message) {
                        this.message = error.response.data.error[0].message;
                    } else {
                        this.message = "Er is een fout opgetreden bij het genereren van het rapport";
                    }
                });
        },
        startPolling() {
            // Start polling elke 5 seconden om notificaties op te halen
            this.pollingInterval = setInterval(() => {
                this.$requests.get('notifications', '/notifications').then(
                    () => {
                        db.notifications.toArray()
                            .then(newNotifications => {
                                if (newNotifications && Array.isArray(newNotifications)) {
                                    // Zoek naar nieuwe notificaties die er eerder nog niet waren
                                    const addedNotifications = newNotifications.filter(newNotification =>
                                        this.existingNotificationIds && !this.existingNotificationIds.includes(newNotification.id)
                                    );

                                    // Voeg de nieuwe notificaties toe aan de bestaande lijst
                                    this.notifications = [...this.notifications, ...addedNotifications];

                                    // Update de lijst van bestaande notificatie-IDs
                                    this.existingNotificationIds = this.notifications.map(notification => notification.id);

                                    // Filter de notificaties om alleen de nieuwste rapporten te selecteren
                                    const recentReportNotifications = addedNotifications.filter(notification =>
                                        notification.type === 'App\\Notifications\\NovacheckNotification' &&
                                        notification.data.subject_type === 'report' &&
                                        notification.data.subject_uuid === this.$store.getters.getInspectionUuid
                                    );

                                    // Stop polling als een nieuw rapport ontvangen is
                                    if (recentReportNotifications.length > 0) {
                                        const latestNotification = recentReportNotifications.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
                                        this.stopPolling();
                                        this.report_generation_status = 'report_ready';
                                        this.config.url = latestNotification.data.actionUrl.url;
                                        console.log(latestNotification.created_at + ': Rapport is klaar');
                                    }
                                }
                            })
                            .catch(error => {
                                console.error('Fout bij ophalen notificaties:', error);
                            });
                    }
                );

            }, 2000);
        },
        stopPolling() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        async closeModal() {
            await modalController.dismiss();
        },
        async share() {
            const inspection = await db.inspections.where('id').equals(parseInt(this.$store.getters.getInspectionId)).first();
            const title = `Inspectie rapportage: ${inspection.name}`;

            try {
                // Controleer of de URL werkt met fetch
                const response = await fetch(this.config.url);
                if (!response.ok) {
                    throw new Error('Fout bij ophalen van de PDF: ' + response.statusText);
                }
                const blob = await response.blob();
                const reader = new FileReader();

                reader.onloadend = async () => {
                    const file_name = `Inspectierapportage_${inspection.name}_${new Date().toLocaleDateString('nl-NL', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-') + '--' + new Date().toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}.pdf`;

                    const base64data = reader.result.split(',')[1];
                    // Sla het bestand op in het bestandssysteem
                    const fileWriteResponse = await Filesystem.writeFile({
                        path: file_name,
                        data: base64data,
                        directory: Directory.Cache
                    });

                    // Maak een bestandspad voor delen
                    const filePath = fileWriteResponse.uri;

                    // Capacitor Share API gebruiken om het bestand te delen
                    await Share.share({
                        title: title,
                        url: filePath, // De URI van het bestand dat gedeeld moet worden
                        dialogTitle: 'Deel Inspectierapport',
                        text: 'Bijgevoegd vindt u het inspectierapport uit Novacheck.'
                    });
                };
                reader.readAsDataURL(blob);

            } catch (error) {
                console.error('Fout bij het delen van de rapportage:', error);
                this.$toast.error('Er is een fout opgetreden bij het delen van de rapportage');
            }
        },
        parseDate(date) {
            if (date) {
                return new Date(date).toLocaleDateString('nl-NL');
            }
            return '-';
        },

    }
};
</script>
